module.exports = __webpack_public_path__ + "img/icon-info.5a3f9244.svg";